import * as React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import MainLayout from 'src/components/layout/MainLayout';
import { PERMISSION } from 'src/features/auth/types';
import { pageTitles } from 'src/features/navigation/utils/messages';
import ValidationsTableAccountDashboard from 'src/features/validations/components/tables/ValidationsTableAccountDashboard';
import { validationMessages } from 'src/features/validations/utils/messages';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';
import { useTitleStore } from 'src/stores/useTitleStore';

export const ValidationLayout = () => {
    const { formatMessage } = useIntl();

    // const accessSearchActiveStaysPermission = useHasPermissions([
    //     PERMISSION.ACCESS_ACTIVE_STAYS,
    //     PERMISSION.ALLOW_VALIDATIONS,
    // ]);
    const accessValidationsPermission = useHasPermissions([PERMISSION.MANAGE_VALIDATIONS]);

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(pageTitles.validation));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    const defaultTabValue = (() => {
        // if (accessSearchActiveStaysPermission) return 'search';
        if (accessValidationsPermission) return 'past-validations';
    })();

    return (
        <MainLayout>
            <div className="grid flex-3 grid-cols-1 pr-8">
                <Tabs defaultValue={defaultTabValue}>
                    <TabsList>
                        {/*{accessSearchActiveStaysPermission && (*/}
                        {/*    <TabsTrigger value="search">*/}
                        {/*        <FormattedMessage {...validationMessages.search} />*/}
                        {/*    </TabsTrigger>*/}
                        {/*)}*/}
                        {accessValidationsPermission && (
                            <TabsTrigger value="past-validations">
                                <FormattedMessage {...validationMessages.pastValidations} />
                            </TabsTrigger>
                        )}
                    </TabsList>

                    {/*{accessSearchActiveStaysPermission && (*/}
                    {/*    <TabsContent value="search" className="w-full">*/}
                    {/*        <ValidationTable />*/}
                    {/*    </TabsContent>*/}
                    {/*)}*/}
                    {accessValidationsPermission && (
                        <TabsContent value="past-validations" className="w-full">
                            <ValidationsTableAccountDashboard />
                        </TabsContent>
                    )}
                </Tabs>
            </div>
        </MainLayout>
    );
};
